import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { STORE_LINKS } from '../../../utils/platform';

const TUTORIALS = [
  {
    id: 'cq5qwKAKQGE',
    title: 'Save words while browsing',
    desc: 'Click a word on any website and save it to your list with the browser extension.',
  },
  {
    id: 'IR9eu1Csi9E',
    title: 'Highlighting',
    desc: 'See your saved words highlighted when they appear again, and hover to see their meaning.',
  },
  {
    id: 'wlDAMfQdTf4',
    title: 'Discover, filter & save vocabulary words',
    desc: 'Browse words by topic and level, filter the list and save the ones you want to learn.',
  },
];

// Shows the thumbnail until clicked, so the page doesn't load three YouTube players up front.
// One video per row, large, alternating sides like the landing page feature rows.
const VideoRow = ({ id, title, desc, step, videoFirst }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <Row className="tutorial-row align-items-center g-4 g-lg-5">
      <Col lg={8} className={videoFirst ? 'order-2 order-lg-1' : 'order-2'}>
        <div className="ratio ratio-16x9 rounded overflow-hidden shadow">
          {playing ? (
            <iframe
              src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          ) : (
            <button
              type="button"
              className="tutorial-thumb"
              onClick={() => setPlaying(true)}
              aria-label={`Play: ${title}`}
            >
              <img
                src={`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`}
                // Not every video has an HD thumbnail; fall back to the one that always exists.
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
                }}
                alt=""
                loading="lazy"
              />
              <span className="tutorial-play">
                <FeatherIcon icon="play" style={{ width: 28, height: 28 }} />
              </span>
            </button>
          )}
        </div>
      </Col>
      <Col lg={4} className={videoFirst ? 'order-1 order-lg-2' : 'order-1'}>
        <p className="feature-eyebrow">Step {step}</p>
        <h4 className="feature-title">{title}</h4>
        <p className="feature-desc mb-0">{desc}</p>
      </Col>
    </Row>
  );
};

const PageTutorials = () => {
  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="mt-5 justify-content-center">
            <Col lg={8} className="text-center">
              <div className="pages-heading">
                <h4 className="title mb-3">Tutorials</h4>
                <p className="text-muted mb-0">
                  Short videos showing how to get the most out of HighVocab.
                </p>
              </div>
            </Col>
          </Row>

          <div className="mt-5">
            {TUTORIALS.map((t, i) => (
              <VideoRow
                key={t.id}
                {...t}
                step={i + 1}
                videoFirst={i % 2 === 0}
              />
            ))}
          </div>

          <div className="text-center mt-5">
            <a
              href={STORE_LINKS.chrome}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              Add to Chrome — it&apos;s free
            </a>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default PageTutorials;
